import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

export const StyledButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 0.5rem;
`;

export const StyledPayPalExpressCheckoutWrapper = styled.div`
  margin: 1.25rem auto auto;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: ${breakpoints.sm}) {
    margin: 1.25rem 0 auto auto;
    width: 12.5rem;
  }
`;
